import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()
@Component({
  selector: 'app-pending-cancel-modal',
  templateUrl: './pending-cancel-modal.component.html',
  styleUrls: ['./pending-cancel-modal.component.css']
})
export class PendingCancelModalComponent implements OnInit {
  @Input() data: any;
  @Output() closeModal = new EventEmitter<any>();
  tripIds: any;
  cancelReason: any;

  constructor(
    private tripService: TripService
  ) { }

  ngOnInit() {
    const { tripIds } = this.data;
    this.tripIds = tripIds;
  }

  setReason(reason: any) {
    this.cancelReason = reason;
  }

  rejectPendingTrip() {
    if (!this.cancelReason) return;
    const payload = {
      status: 'rejected',
      selectedIds: this.tripIds,
      changeReasonNotes: this.cancelReason
    }
    this.tripService
      .updatePendingTripStatus(payload)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data) {
          this.closeModal.emit({
            changeReasonNotes: this.cancelReason,
            ...data
          });
        }
      });
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}
